import { Divider, Grid } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import {
  getLocalValue,
  IRoleMain,
  LoacalVariables,
  MasterPages
} from "../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { HeaderList } from "../../Components/Header/HeaderList";
import PermissionDenied from "../../commonFunctions/PermissionDenied";

export const AddOnServiceList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { edit, add, view, exports } = getPermissions(
    MasterPages.Product,
    IRoleMain.Masters
  );
  const [totalCount, setTotalCount] = useState<any>();
  const source = {
    url: "service-addons/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

  /**
   *  Edit function
   * @param action
   * @param row
   */
  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/add-on-service/${row?.addOnId}`);
    }
  };

  const columns: IColumns[] = [
    {
      header: "Add On",
      fieldName: "addOnName",
      type: "default"
    },
    {
      header: "Price",
      fieldName: "price",
      type: "default"
    },

    {
      header: "Updated On",
      fieldName: "updatedDate",
      type: "date"
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const handleClick = () => {
    navigate("/add-on-service/create");
  };
  const transFormData = (data: any, totalCount: any) => {
    setTotalCount(totalCount);
    return data;
  };
  return (
    <>
      {" "}
      <HeaderList
        title="Add On Services"
        type="card"
        info={`${totalCount || 0} Total Records`}
      />
      {view ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="serviceAddOnGrid"
              title="Add On Service"
              columns={columns}
              headerType="HaderTopCornered"
              source={source}
              onAddButtonClick={handleClick}
              transFormData={transFormData}
              exportCsv={exports}
              addButton={add ? { label: "", color: "secondary" } : undefined}
            />
          </Grid>
        </Grid>
      ) : (
        <PermissionDenied />
      )}
    </>
  );
});
